import { apiFetch } from "./apiClient";

export function listarCuentas() {
    return apiFetch("/api/cuentas");
}

export function obtenerCuenta(id) {
    return apiFetch(`/api/cuentas/${id}`);
}

export function crearCuenta(payload) {
    return apiFetch("/api/cuentas", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export function actualizarCuenta(id, payload) {
    return apiFetch(`/api/cuentas/${id}`, {
        method: "PUT",
        body: JSON.stringify(payload),
    });
}

export function inactivarCuenta(id) {
    return apiFetch(`/api/cuentas/inactivar/${id}`, {
        method: "PUT",
    });
}

export function listarMovimientosCuenta(id) {
    return apiFetch(`/api/cuentas/${id}/movimientos`);
}

export function registrarTransferencia(payload) {
    return apiFetch("/api/cuentas/transferencia", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export function activarCuenta(idCuenta) {
    return apiFetch(`/api/cuentas/activar/${idCuenta}`, {
        method: "PUT",
    });
}